import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import Big from 'UIComponents/elements/Big';
import H3 from 'UIComponents/elements/headings/H3';
import UIGrid from 'UIComponents/grid/UIGrid';
import UIGridItem from 'UIComponents/grid/UIGridItem';
import UISection from 'UIComponents/section/UISection';
import MediaQuery from 'marketplace-ui-common/layout/components/MediaQuery';
import * as ScreenSizes from 'ecosystem-marketplace-core/constants/layout/ScreenSizes';

const StorefrontSection = ({
  children,
  className,
  primaryGridSize = 5,
  subtitle,
  title,
  titleControls,
  titleControlsMobile = ScreenSizes.SM
}) => {
  const secondaryGridSize = 12 - primaryGridSize;
  return /*#__PURE__*/_jsxs(UISection, {
    className: className,
    children: [/*#__PURE__*/_jsxs(UIGrid, {
      className: "align-end m-bottom-7",
      children: [/*#__PURE__*/_jsxs(UIGridItem, {
        size: {
          xs: 12,
          sm: primaryGridSize
        },
        children: [/*#__PURE__*/_jsx(H3, {
          className: !subtitle ? 'm-bottom-0' : "",
          children: title
        }), subtitle && /*#__PURE__*/_jsx(Big, {
          children: subtitle
        })]
      }), /*#__PURE__*/_jsx(MediaQuery, {
        minScreenSize: titleControlsMobile,
        children: /*#__PURE__*/_jsx(UIGridItem, {
          className: "text-right",
          size: {
            xs: 12,
            sm: secondaryGridSize
          },
          children: titleControls
        })
      })]
    }), children, /*#__PURE__*/_jsx(MediaQuery, {
      maxScreenSize: titleControlsMobile,
      children: /*#__PURE__*/_jsx("div", {
        children: titleControls
      })
    })]
  });
};

export default StorefrontSection;